import { Box, Skeleton, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

import { useIsMarketCN } from '../../../hooks/useIsMarketCN';
import { SKELETON_CATALOGUE_DESKTOP, SKELETON_CATALOGUE_DESKTOP_CONTENT } from './constants';

const SkeletonCatalogueDesktopRoot = styled(Box)(({ theme }) => ({
  gridColumnStart: 1,
  margin: theme.spacing(2, 'auto', 5),
  paddingRight: theme.spacing(3),

  '& > *': {
    margin: 'auto',
  },
}));

const SkeletonCatalogueDesktopValidity = styled(Skeleton)(({ theme }) => ({
  margin: theme.spacing(1, 'auto', 1),
}));

const SkeletonCatalogueDesktopContent = styled(Skeleton)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const SkeletonCatalogueDesktopSeeAll = styled(Skeleton)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const SkeletonCatalogueDesktop = () => {
  const isMarketCN = useIsMarketCN();
  const { getTestId } = useTestId();

  return (
    <SkeletonCatalogueDesktopRoot data-testid={getTestId(SKELETON_CATALOGUE_DESKTOP)}>
      <Skeleton
        animation="wave"
        variant="text"
        width={100}
        height={32}
      />
      <SkeletonCatalogueDesktopValidity
        animation="wave"
        variant="text"
        width={130}
        height={27}
      />
      <SkeletonCatalogueDesktopContent
        animation="wave"
        variant="rectangular"
        width={310}
        data-testid={getTestId(SKELETON_CATALOGUE_DESKTOP_CONTENT)}
        height={isMarketCN ? 286 : 440}
      />
      <SkeletonCatalogueDesktopSeeAll
        animation="wave"
        variant="text"
        width={42}
        height={25}
      />
    </SkeletonCatalogueDesktopRoot>
  );
};
